import React from "react";
import { Input } from "antd";
import { FilterField } from "./FilterShared";

const IdentityPanel = ({ values, setE }) => {
  return (
    <div className="qp-filter-panel-body">
      <FilterField label="Name">
        <Input
          placeholder="e.g. Jane Smith"
          value={values.name}
          onChange={setE("name")}
        />
      </FilterField>
    </div>
  );
};

export default IdentityPanel;
